import {
  useState, useCallback, useEffect,
} from 'react';
import { IStorageService, storageService } from '../../QnAConfigModal/services/StorageService';

export interface UseContextManagerReturn {
  context: string | null;
  updateContext: (newContext: string) => Promise<void>;
}

export function useContextManager(
  storageServiceInstance: IStorageService = storageService,
): UseContextManagerReturn {
  const [context, setContext] = useState<string | null>(null);

  const loadInitialContext = useCallback(async () => {
    const storedContext = await storageServiceInstance.loadContext();
    if (storedContext) {
      setContext(storedContext);
    }
  }, [storageServiceInstance]);

  useEffect(() => {
    loadInitialContext();
  }, [loadInitialContext]);

  const updateContext = useCallback(async (newContext: string) => {
    setContext(newContext);
    await storageServiceInstance.saveContext(newContext);
  }, [storageServiceInstance]);

  return {
    context,
    updateContext,
  };
}
